declare global {
  interface Window {
    __APP_CONFIG__?: { environment?: string };
  }
}

export const getEnvironment = (): string =>
  window.__APP_CONFIG__?.environment || process.env.REACT_APP_ENV || process.env.NODE_ENV;
